import FeedbackIcon from "@mui/icons-material/Feedback";
import { Box, Button, Container, Link, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import contactInfo from "../../data/contactInfo.json";
import { secondaryButton } from "../../styles/commonStyles";
import { footerContainer, footerCopyright, footerLink, footerStack } from "../../styles/footerStyles";
import NewsletterModal from "../Modals/NewsletterModal";
import { feedbackFormLinks } from "./utils";

const FooterLink = ({ href, label }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Link href={href} underline="hover" sx={footerLink(theme)} aria-label={t(`${label}.ariaLabel`)}>
      {t(label)}
    </Link>
  );
};

const Footer = () => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const currentYear = new Date().getFullYear();

  const feedbackURL = i18n.language === "en" ? feedbackFormLinks.en : feedbackFormLinks.ee;

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box component="footer" sx={footerContainer(theme)}>
      <Container>
        {/* Subscribe & Feedback */}
        <Stack direction={{ xs: "row", md: "row" }} spacing={2} justifyContent="center" alignItems="center" mb={1}>
          <Button variant="contained" onClick={() => setIsModalOpen(true)} aria-label={t("subscribe")} sx={secondaryButton(theme)}>
            {t("subscribe")}
          </Button>
          <Tooltip title={t("giveFeedback")} arrow>
            <Link href={feedbackURL} target="_blank" rel="noopener noreferrer" aria-label={t("giveFeedback")}>
              <FeedbackIcon fontSize="large" />
            </Link>
          </Tooltip>
        </Stack>

        {/* Navigation Links */}
        <Stack sx={footerStack}>
          {["contact", "about", "privacyPolicy", "termsOfService"].map((key) => (
            <FooterLink key={key} href={`/${key}`} label={key} />
          ))}
        </Stack>

        {/* Copyright */}
        <Typography variant="body2" align="center" sx={footerCopyright(theme)}>
          &copy; {currentYear} {contactInfo.companyName}. {t("allRightsReserved")}
        </Typography>

        <NewsletterModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
      </Container>
    </Box>
  );
};

export default Footer;
